module.exports = __webpack_public_path__ + "static/media/First5_Post05-Image.0c3a4b16.jpg";